export default "__VITE_ASSET__CtSB8GCo__"